<template>
  <div id="app">
    <div class="page">
      <div class="canvas">
        <router-view>
          <b-alert
              style="margin:10px"
              :show="alertDismissCountDown"
              dismissible
              :variant="this.alertType"
              @dismissed="alertDismissCountDown=0"
              @dismiss-count-down="alertCountDownChanged">
            {{ this.alertMessage }}
            <b-progress
                variant="warning"
                :max="5"
                :value="alertDismissCountDown"
                height="3px"
                style="margin-top:4px"
            ></b-progress>
          </b-alert>

          <b-overlay :show="this.loading" rounded="sm" style="height:100%">
            <router-view style="height:100%" v-on:showLoading="showLoading" />
          </b-overlay>
        </router-view>
      </div>
    </div>

    <b-modal
        id="modal-maintenance"
        v-model="showMaintenance"
        title="Pemberitahuan Sistem"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        centered
        header-bg-variant="danger"
        header-text-variant="light"
    >
      <div class="text-center p-3">
        <div style="font-size: 3rem; margin-bottom: 1rem;">🛠️</div>
        <h5 class="mb-3">Sistem Sedang Dalam Pemeliharaan</h5>
        <p class="text-muted">{{ maintenanceText }}</p>
      </div>

      <template #modal-footer>
        <b-button variant="primary" block @click="reloadPage">
          Cek Kembali / Refresh
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      loading:false,
      alertDismissCountDown: 0,
      alertMessage: "",
      alertType :"info",
      messageContent:"",
      showMaintenance: false,
      maintenanceText: "Mohon maaf, sistem sedang dalam perbaikan untuk meningkatkan layanan kami. Silakan coba beberapa saat lagi."
    }
  },
  created() {
    if (this.$eventBus) {
      this.$eventBus.$on('trigger-maintenance', (msg) => {
        if(msg) this.maintenanceText = msg;
        this.showMaintenance = true;
        this.loading = false;
      });
    }
  },
  beforeDestroy() {
    if (this.$eventBus) {
      this.$eventBus.$off('trigger-maintenance');
    }
  },
  methods: {
    alertCountDownChanged(alertDismissCountDown) {
      this.alertDismissCountDown = alertDismissCountDown
    },
    showLoading (show){
      if(!this.showMaintenance) {
        this.loading = show;
      }
    },
    showAlert(message,type){
      this.messageContent = message;
      if(this.$refs['showMessageDlg']) this.$refs['showMessageDlg'].show();
    },
    showMessage(message){
      this.messageContent = message;
      if(this.$refs['showMessageDlg']) this.$refs['showMessageDlg'].show();
    },
    reloadPage(){
      window.location.reload();
    }
  }
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>